module.exports = __webpack_public_path__ + "img/portfolio.a7e5595b.svg";